import React from 'react';
import { useSelector } from 'react-redux';
import { isCaseworker } from '@debbie/common/dist/permissions/index.js';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors.js';
import { SearchInput, Checkbox } from '../../../../index.js';
import { Row, Col } from '../../../../Grid/index.js';
import MoneyInput from '../../../../MoneyInput.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const Rubrik8 = (props) => {
    const { courtFee, sendInfoToEconomyResponsible, addCourtFeeToCase, addCourtDisbursementToClientBilling, addCourtFeeToClientBilling, setDocumentState, economyResponsibleUserId, setEconomyResponsibleUserId, } = props;
    const lang = useSelector((s) => s.lang);
    const allUsers = useSelector(selectAllUsers);
    const tenant = useSelector(selectTenant);
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 8"),
            React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(MoneyInput, { placeholder: lang.documents.paidCourtFee, value: courtFee, allowNull: true, onChange: (c) => {
                            setDocumentState({
                                courtFee: c === null ? c : Math.abs(c),
                            });
                        } })),
                React.createElement(Col, { width: "12" },
                    React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToCase, checked: addCourtFeeToCase, onChange: (e) => {
                            setDocumentState({
                                addCourtFeeToCase: e.target.checked,
                            });
                        } }),
                    tenant?.type === TenantType.Agency && (React.createElement(React.Fragment, null,
                        React.createElement(Checkbox, { placeholder: lang.documents.addCourtDisbursementToClientBilling, checked: addCourtDisbursementToClientBilling, onChange: (e) => {
                                setDocumentState({
                                    addCourtDisbursementToClientBilling: e.target.checked,
                                });
                            } }),
                        React.createElement(Checkbox, { placeholder: lang.documents.addCourtFeeToClientBilling, checked: addCourtFeeToClientBilling, onChange: (e) => {
                                setDocumentState({
                                    addCourtFeeToClientBilling: e.target.checked,
                                });
                            } }))),
                    React.createElement(Checkbox, { placeholder: lang.documents.sendInfoAboutRequisitionToRes, checked: sendInfoToEconomyResponsible, onChange: (e) => {
                            setDocumentState({
                                sendInfoToEconomyResponsible: e.target.checked,
                            });
                        } }),
                    sendInfoToEconomyResponsible && (React.createElement(SearchInput, { searchAll: (q) => allUsers
                            ? allUsers
                                .filter((t) => (`${t.firstName} ${t.lastName}`
                                .toLowerCase()
                                .indexOf(q.toLowerCase()) !== -1 ||
                                q.length === 0) &&
                                isCaseworker(t.role))
                                .map((t) => ({
                                key: t.id,
                                heading: `${t.firstName} ${t.lastName}`,
                                subheading: t.role,
                                returnData: t,
                            }))
                            : [], onSelect: (result) => {
                            setEconomyResponsibleUserId(result.id);
                            localStorage.setItem('economyResponsibleUserId', result.id || '');
                        }, static: (() => {
                            const user = allUsers &&
                                allUsers.find((t) => t.id === economyResponsibleUserId);
                            return ((user && `${user.firstName} ${user.lastName}`) ||
                                economyResponsibleUserId);
                        })(), onRemoveStatic: () => {
                            setEconomyResponsibleUserId('');
                            localStorage.setItem('economyResponsibleUserId', '');
                        }, searchDelay: 0, forceOpen: true, placeholder: lang.documents.responsible })))))));
};
export default Rubrik8;
//# sourceMappingURL=Rubrik8.js.map